/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  SimpleLiquidator,
  SimpleLiquidatorInterface,
} from "../SimpleLiquidator";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "LiquidationAmountTooSmall",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "contract ISilo",
        name: "_silo",
        type: "address",
      },
    ],
    name: "executeLiquidation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_assets",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "_shareAmountsToRepay",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "siloLiquidationCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type SimpleLiquidatorConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SimpleLiquidatorConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SimpleLiquidator__factory extends ContractFactory {
  constructor(...args: SimpleLiquidatorConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "SimpleLiquidator";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SimpleLiquidator> {
    return super.deploy(overrides || {}) as Promise<SimpleLiquidator>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): SimpleLiquidator {
    return super.attach(address) as SimpleLiquidator;
  }
  connect(signer: Signer): SimpleLiquidator__factory {
    return super.connect(signer) as SimpleLiquidator__factory;
  }
  static readonly contractName: "SimpleLiquidator";
  public readonly contractName: "SimpleLiquidator";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SimpleLiquidatorInterface {
    return new utils.Interface(_abi) as SimpleLiquidatorInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SimpleLiquidator {
    return new Contract(address, _abi, signerOrProvider) as SimpleLiquidator;
  }
}
